// apps/web/src/pages/spread/SpreadComposerShell.tsx
//
// Phase 9 Plan 11 Task 2 — page-level shell.
//
// Wraps the toolbar + SplitPane composition per UI-SPEC §"Spread Composer
// shell" lines 130-155. Reuses the existing Phase 8 SplitPane primitive (the
// resizable W3C Window Splitter pattern) — Phase 9 does NOT introduce a new
// split surface.
//
// Left: <SpreadLeftPanel> — tab strip + batch-set strip.
// Right: <SpreadRenderPane> — RecipeStateProvider + TemplateRenderer chain.

import type * as React from "react";
import { SplitPane } from "@/components/layout/SplitPane";
import { SpreadLeftPanel } from "./SpreadLeftPanel";
import { SpreadRenderPane } from "./SpreadRenderPane";

export interface SpreadComposerShellProps {
  /** Currently-loaded spread id (or "new" sentinel for /spread/new). */
  spreadId: string;
  /** Toolbar element rendered above the split pane. */
  toolbar: React.ReactNode;
  /** Click handler for the "+ New {container}" button in the tab strip. */
  onCreateNewSpread?: (() => void) | undefined;
}

export function SpreadComposerShell(props: SpreadComposerShellProps): React.ReactElement {
  return (
    <main aria-label="Spread composer" className="flex h-screen flex-col">
      {props.toolbar}
      <div className="flex-1 min-h-0">
        <SplitPane
          storageKey="trs:spread:split-ratio"
          defaultRatio={0.4}
          minRatio={0.2}
          maxRatio={0.8}
          ariaControls="spread-render-pane"
          leftChildren={
            <SpreadLeftPanel
              activeSpreadId={props.spreadId}
              onCreateNewSpread={props.onCreateNewSpread}
            />
          }
          rightChildren={<SpreadRenderPane spreadId={props.spreadId} />}
        />
      </div>
    </main>
  );
}
SpreadComposerShell.displayName = "SpreadComposerShell";
